import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`我是 Gelis，從事軟體專案開發相關工作已經 20 餘年 (顧問工作 5 年)，專案開發 15 年，目前任職資深 .NET 技術顧問，目前主要負責與 .NET 相關的開發、顧問與訓練工作。`}</p>
    <p>{`我熱愛軟體工程、UML 系統分析與設計，擅長 OO 物件導向分析與設計外，也擅長將看似與程式碼無關的 OOA 與 OOD 的設計模型推導為實際程式碼設計，專精於 .NET 平台網頁 ASP.NET Web Form 與 MVC 開發與 WinForm 開發，領域包含了 WinForm、WPF 等。`}</p>
    <p>{`主要負責軟體開發架構、流程的導入的顧問工作，主要核心價值在於在導入適當的開發平台 Platform 框架 Framework，配合 (Team Foundation Server, TFS) 產品與 ALM 的 Scrum 流程，搭配自動化 Code-Review 並結合 Team Build 進行自動化測試，自動化部署 (Continuous Deployment, CD)，並達到持續整合 (Cintinuous Integrated, CI)，以提升開發團隊的效率與價值。`}</p>
    <p>{`曾經連任七屆微軟最有價值專家 MVP (2011 ~ 2017)，有個人的技術部落格 『Gelis 技術隨筆』，以記錄在技術上學習的新知與個人的研究發表。`}</p>
    <p>{`講師經歷：`}</p>
    <ul>
      <li parentName="ul">{`2015 集英信誠 - 與大師對談講師`}</li>
      <li parentName="ul">{`Visual Studio Everywhere 2017 台北場講師`}</li>
      <li parentName="ul">{`.NET Conf Taiwan 2018/2019 講師`}</li>
      <li parentName="ul">{`Study4.TW 社群講師`}</li>
      <li parentName="ul">{`企業內訓講師`}</li>
    </ul>
    <p>{`現職：`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`集英信誠 資深 .NET 技術顧問`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`部落格 (Gelis 技術隨筆)：`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "http://gelis-dotnet.blogspot.tw"
            }}>{`http://gelis-dotnet.blogspot.tw`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.dotblogs.com.tw/gelis/"
            }}>{`https://www.dotblogs.com.tw/gelis/`}</a></li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`FB 社團 (軟體開發之路)：`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.facebook.com/groups/361804473860062/"
            }}>{`https://www.facebook.com/groups/361804473860062/`}</a></li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`FB 粉絲團 (Gelis 的程式設計訓練營)：`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.facebook.com/gelis.dev.learning/"
            }}>{`https://www.facebook.com/gelis.dev.learning/`}</a></li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`我講授過的課程 SlideShare：`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.slideshare.net/GelisWu"
            }}>{`https://www.slideshare.net/GelisWu`}</a></li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Github：`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://github.com/wugelis"
            }}>{`https://github.com/wugelis`}</a></li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      